import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const STORAGE_KEY = "schoolos-selected-child";

/**
 * Hook to load a parent's children and manage which one is currently selected.
 * Returns { children, selected, selectedId, setSelected, showSelector, loading }.
 * Only makes the API call when the current user is a parent.
 */
export function useParentChildren() {
  const { user } = useAuth();
  const [children, setChildren] = useState([]);
  const [selectedId, setSelectedId] = useState(() => localStorage.getItem(STORAGE_KEY));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user?.role !== "parent") return;
    setLoading(true);
    api.get("/parent/children")
      .then((r) => {
        setChildren(r.data);
        setSelectedId((cur) => {
          if (cur && r.data.some((c) => c.id === cur)) return cur;
          return r.data[0]?.id || null;
        });
      })
      .finally(() => setLoading(false));
  }, [user?.role]);

  const setSelected = (id) => {
    setSelectedId(id);
    if (id) localStorage.setItem(STORAGE_KEY, id);
  };

  const selected = children.find((c) => c.id === selectedId) || children[0] || null;

  return {
    children,
    selected,
    selectedId: selected?.id || null,
    setSelected,
    showSelector: children.length > 1,
    loading,
  };
}
